import { useMemo } from 'react'

import _ from 'lodash'
import { useRouteMatch } from 'react-router-dom'

import {
  ListNav2,
  LoadingContainer,
  Panels,
  Breadcrumb,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams } from 'peach/router'

import { useInternalBorrowerGet, useLoansGetAll } from 'core/types'

import PersonRoutes from './PersonRoutes'

const Person = () => {
  const { url } = useRouteMatch()
  const { companyId, personId } = useParams<{
    companyId?: string
    personId?: string
  }>()

  const {
    data: person,
    isLoading: isLoadingPerson,
    error: errorPerson,
  } = useInternalBorrowerGet({ companyId, personId })

  const {
    data: loans,
    isLoading: isLoadingLoans,
    error: errorLoans,
  } = useLoansGetAll({ personId })

  const name = getName(person)

  const items = useMemo(() => {
    const groupedByStatus = _.groupBy(loans ?? [], 'status')
    const pairs = _.sortBy(_.toPairs(groupedByStatus), (pair) => pair[0])

    const sections = _.map(pairs, (pair) => {
      const [status, loanGroup] = pair

      const items = _.map(loanGroup, (loan) => ({
        key: loan.id,
        label: getName(loan),
        to: `/loans/${loan.id}`,
        note: loan.id,
      }))
      const label = _.str.humanize(status) + ' Loans'

      return { label, items, key: `loans-group--${label}` }
    })

    return [
      ['Borrower', '', true],
      '/contacts',
      '/payment-instruments',
      '/consents',
      '/interactions',
      '/cases',
      '/documents',
      { label: 'Loans', to: '/loans', exact: true },
      ...sections,
    ]
  }, [loans, name])

  const nav = <ListNav2 baseUrl={url} items={items} searchable />

  const isLoading = isLoadingPerson || isLoadingLoans
  const error = errorPerson ?? errorLoans

  return (
    <Panels left={nav}>
      <Breadcrumb title={name} to={url} />
      <LoadingContainer error={error} isLoading={isLoading}>
        <PersonRoutes loans={loans} person={person} />
      </LoadingContainer>
    </Panels>
  )
}

export default Person
